const add = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path stroke-width="1.5" d="M8 3v10"/><path stroke-width="1.5" d="M13 8H3"/></svg>',
};

export { add as default };
